import { useQuery } from '@apollo/client';
import { GET_DASHBOARD_METRIC_LIST, MetricItem } from '@frontend/data-access';
import { Button, Skeleton } from 'antd';
import useTranslation from 'next-translate/useTranslation';

interface MetricsListProps {
  onChange: (metricId: string | null) => void;
  metricId?: string;
}

function MetricsList({ onChange, metricId }: MetricsListProps) {
  const { t } = useTranslation('common');

  const { data, loading } = useQuery<{
    dashboardMetricList: MetricItem[];
  }>(GET_DASHBOARD_METRIC_LIST);

  if (loading) {
    return (
      <div className="flex gap-2">
        <Skeleton.Button active shape="round" />
        <Skeleton.Button active shape="round" />
        <Skeleton.Button active shape="round" />
        <Skeleton.Button active shape="round" />
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-2">
      <Button
        type={!metricId ? 'primary' : 'default'}
        shape="round"
        onClick={() => onChange(null)}
      >
        {t('all_metrics')}
      </Button>
      {data?.dashboardMetricList.map((item) => (
        <Button
          key={item.id}
          type={metricId === item.id ? 'primary' : 'default'}
          shape="round"
          onClick={() => onChange(item.id)}
        >
          {item.name}
        </Button>
      ))}
    </div>
  );
}

export default MetricsList;
